import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
import { FooterBrand } from './FooterBrand';
import { FooterCopyright } from './FooterCopyright';
import { FooterDivider } from './FooterDivider';
import { FooterIcon } from './FooterIcon';
import { FooterLink } from './FooterLink';
import { FooterLinkGroup } from './FooterLinkGroup';
import { FooterTitle } from './FooterTitle';
export var FooterComponent = function FooterComponent(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$bgDark = _ref.bgDark,
    bgDark = _ref$bgDark === void 0 ? false : _ref$bgDark,
    _ref$container = _ref.container,
    container = _ref$container === void 0 ? false : _ref$container;
  var theme = useTheme().theme.footer;
  return _jsx("footer", {
    "data-testid": "flowbite-footer",
    className: classNames(theme.base, bgDark && theme.bgDark, container && theme.container, className),
    children: children
  });
};
FooterComponent.displayName = 'Footer';
FooterCopyright.displayName = 'Footer.Copyright';
FooterLink.displayName = 'Footer.Link';
FooterBrand.displayName = 'Footer.Brand';
FooterLinkGroup.displayName = 'Footer.LinkGroup';
FooterIcon.displayName = 'Footer.Icon';
FooterTitle.displayName = 'Footer.Title';
FooterDivider.displayName = 'Footer.Divider';
export var Footer = Object.assign(FooterComponent, {
  Copyright: FooterCopyright,
  Link: FooterLink,
  LinkGroup: FooterLinkGroup,
  Brand: FooterBrand,
  Icon: FooterIcon,
  Title: FooterTitle,
  Divider: FooterDivider
});